<script setup lang="ts">
import AppLogoIcon from '@/components/AppLogoIcon.vue';
</script>

<template>
    <AppLogoIcon uid="app-logo" class="size-8 flex-none" />
    <div class="ml-2 grid flex-1 text-left text-sm">
        <span
            class="font-display truncate text-[15px] leading-tight font-semibold tracking-tight"
        >
            CreativeTint
        </span>
        <span
            class="truncate text-[10px] font-medium tracking-wider text-muted-foreground uppercase"
        >
            AI Studio
        </span>
    </div>
</template>
